import { ProjectValueApplicationVersion } from 'ze-api-contract/project-v2/get-project';

export function getLatestProjectVersion(versions: ProjectValueApplicationVersion[]) {
  return versions.length ? versions[0] : undefined;
}
